import { ReactNode, useMemo } from 'react';
import { LibraryContext } from 'app/shared/u21-ui/components/contexts';
import { U21Themes } from 'vendor/material-minimal/models';
import { U21Theme } from 'vendor/material-minimal';

interface Props {
  children: ReactNode;
  direction?: 'ltr' | 'rtl';
  disableExternalLinkModal?: boolean;
  mode?: 'light' | 'dark';
  reportError?: typeof console.error;
}

export const U21ComponentLibrary = (props: Props) => {
  const {
    children,
    direction = 'ltr',
    disableExternalLinkModal = false,
    // eslint-disable-next-line no-console
    reportError = console.error,
    mode = U21Themes.LIGHT,
  } = props;

  const contextValue = useMemo(
    () => ({ disableExternalLinkModal, reportError }),
    [disableExternalLinkModal, reportError],
  );

  return (
    <LibraryContext.Provider value={contextValue}>
      <U21Theme direction={direction} mode={mode}>
        {children}
      </U21Theme>
    </LibraryContext.Provider>
  );
};
